import { render, staticRenderFns } from "./Inputy.vue?vue&type=template&id=e2c0aad4&"
import script from "./Inputy.vue?vue&type=script&lang=js&"
export * from "./Inputy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Inputy.vue"
export default component.exports